import { useState } from 'react';
import { FarmTypeClient, FarmTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useFarmTypeApi = () => {
    const apiClient = new FarmTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: FarmTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createFarmType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating FarmType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: FarmTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateFarmType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating FarmType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getFarmTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching FarmType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchFarmTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching FarmTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteFarmType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting FarmType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};